export enum FormAction {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export enum FormActionStep {
  APPROVAL = 'APPROVAL',
  CONFIRMATION = 'CONFIRMATION',
  DONE = 'DONE',
}
